// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3TK8w","menu":"styles_menu__3L2Sm"};